import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@unite-us/ui';

class CaseFooterButtons extends Component {
  constructor(props) {
    super(props);

    this.onSubmitForm = this.onSubmitForm.bind(this);
  }

  onSubmitForm() {
    this.props.onSubmitForm();
  }

  render() {
    const {
      onCancel,
      submitting,
    } = this.props;

    return (
      <div className="case-footer-buttons">
        <Button
          id="cancel-btn"
          onClick={onCancel}
          label="Cancel"
          disabled={submitting}
        />
        <Button
          id="create-case-btn"
          onClick={this.onSubmitForm}
          className="create-case-btn ml-one"
          label="Create Case"
          disabled={submitting}
          primary
        />
      </div>
    );
  }
}

CaseFooterButtons.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmitForm: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
};

CaseFooterButtons.defaultProps = {
  submitting: false,
};

export default CaseFooterButtons;
